import { useTranslation } from '../../../utils/useTranslation';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { BusinessStatisticItem } from './parts/BusinessStatisticItem/BusinessStatisticItem';
import { BusinessStatisticMainItem } from './parts/BusinessStatisticMainItem/BusinessStatisticMainItem';
import { BusinessStatisticSection } from './parts/BusinessStatisticSection/BusinessStatisticSection';
import { BusinessStatisticSummaryProps } from './types';

export const BusinessStatisticSummary = (props: BusinessStatisticSummaryProps) => {
    const t = useTranslation();
    const { statistic } = props;
    const { coverage, involved, showsInGrid, shows, subscribers, interactions } = statistic;

    return (
        <Flex width="100%" flexWrap="wrap" direction="row" alignItems="stretch">
            {coverage ? (
                <BusinessStatisticSection
                    title={t('Охват')}
                    helpMessage={
                        <>
                            <Typography variant="caption" weight="bold" color="var(--color-invert)">
                                {t('Охват')}
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - количество уникальных аккаунтов, владельцы которых хотя бы 1 раз видели ваш контент за выбранный период с изменением в процентах относительного предыдущего периода.',
                                    )}
                                </Typography>
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t(
                                    'Эта метрика находится в разработке и возможны изменения в расчетах.',
                                )}
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t(
                                    'Охват считается отдельно для пользователей- подписчиков и пользователей, которые не подписаны на профиль.',
                                )}
                            </Typography>
                        </>
                    }
                    statsSlot={
                        <>
                            <BusinessStatisticMainItem
                                text={t('Количество уникальных аккаунтов')}
                                displayValue={coverage.total.display}
                                diffValue={coverage.total.diffValue}
                                diffDisplay={coverage.total.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Подписчики')}
                                displayValue={coverage.subscribers.display}
                                diffValue={coverage.subscribers.diffValue}
                                diffDisplay={coverage.subscribers.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Не подписчики')}
                                displayValue={coverage.notsubscribers.display}
                                diffValue={coverage.notsubscribers.diffValue}
                                diffDisplay={coverage.notsubscribers.diffDisplay}
                            />
                        </>
                    }
                    borderRight={{ xs: 'none', sm: '1px solid var(--divider)' }}
                />
            ) : null}

            {involved ? (
                <BusinessStatisticSection
                    title={t('Вовлеченные аккаунты')}
                    helpMessage={
                        <>
                            <Typography variant="caption" weight="bold" color="var(--color-invert)">
                                {t('Вовлеченные аккаунты')}
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - количество уникальных аккаунтов, владельцы которых совершили какое-либо полезное действие с контентом профиля за выбранный период с изменением в процентах относительного предыдущего периода. Полезные действия - подписка, лайк, сохранение в избранное, поделиться контентом.',
                                    )}
                                </Typography>
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t(
                                    'Эта метрика находится в разработке и возможны изменения в расчетах.',
                                )}
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t(
                                    'Вовлеченные аккаунты считаются отдельно для пользователей - подписчиков и пользователей, которые не подписаны на профиль.',
                                )}
                            </Typography>
                        </>
                    }
                    statsSlot={
                        <>
                            <BusinessStatisticMainItem
                                text={t(
                                    'Количество уникальных аккаунтов, владельцы которых совершили какое-либо полезное действие',
                                )}
                                displayValue={involved.total.display}
                                diffValue={involved.total.diffValue}
                                diffDisplay={involved.total.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Подписчики')}
                                displayValue={involved.subscribers.display}
                                diffValue={involved.subscribers.diffValue}
                                diffDisplay={involved.subscribers.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Не подписчики')}
                                displayValue={involved.notsubscribers.display}
                                diffValue={involved.notsubscribers.diffValue}
                                diffDisplay={involved.notsubscribers.diffDisplay}
                            />
                        </>
                    }
                />
            ) : null}

            {showsInGrid ? (
                <BusinessStatisticSection
                    title={t('Показы в ленте')}
                    helpMessage={
                        <>
                            <Typography variant="caption" weight="bold" color="var(--color-invert)">
                                {t('Показы в ленте')}
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(' - все показы ваших постов в ленте.')}
                                </Typography>
                            </Typography>
                        </>
                    }
                    statsSlot={
                        <>
                            <BusinessStatisticMainItem
                                text={t('Все показы ваших постов в ленте')}
                                displayValue={showsInGrid.total.display}
                                diffValue={showsInGrid.total.diffValue}
                                diffDisplay={showsInGrid.total.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Подписчики')}
                                displayValue={showsInGrid.subscribers.display}
                                diffValue={showsInGrid.subscribers.diffValue}
                                diffDisplay={showsInGrid.subscribers.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Не подписчики')}
                                displayValue={showsInGrid.notsubscribers.display}
                                diffValue={showsInGrid.notsubscribers.diffValue}
                                diffDisplay={showsInGrid.notsubscribers.diffDisplay}
                            />
                        </>
                    }
                    borderRight={{ xs: 'none', sm: '1px solid var(--divider)' }}
                />
            ) : null}

            {shows ? (
                <BusinessStatisticSection
                    title={t('Показы с действием')}
                    helpMessage={
                        <>
                            <Typography variant="caption" weight="bold" color="var(--color-invert)">
                                {t('Показы с действием')}
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - показы с активным взаимодействием пользователя с постом, таких как открытие полноэкранного формата поста на ya.ru, открытие поста в вебе или приложении, наведение на пост, лайки, сохранения и тд.',
                                    )}
                                </Typography>
                            </Typography>
                        </>
                    }
                    statsSlot={
                        <>
                            <BusinessStatisticMainItem
                                text={
                                    <>
                                        {t(
                                            'Показы с активным взаимодействием пользователя с постом',
                                        )}
                                    </>
                                }
                                displayValue={shows.total.display}
                                diffValue={shows.total.diffValue}
                                diffDisplay={shows.total.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Подписчики')}
                                displayValue={shows.subscribers.display}
                                diffValue={shows.subscribers.diffValue}
                                diffDisplay={shows.subscribers.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Не подписчики')}
                                displayValue={shows.notsubscribers.display}
                                diffValue={shows.notsubscribers.diffValue}
                                diffDisplay={shows.notsubscribers.diffDisplay}
                            />
                        </>
                    }
                />
            ) : null}

            {subscribers ? (
                <BusinessStatisticSection
                    title={t('Подписчики')}
                    helpMessage={
                        <>
                            <Typography variant="caption" weight="bold" color="var(--color-invert)">
                                {t('Подписчики')}
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(' - количество аккаунтов, подписавшихся на профиль за ')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    weight="bold"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t('весь срок существования профиля')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(' с изменением в количестве подписавшихся за ')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    weight="bold"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t('выбранный период')}
                                </Typography>
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t('.')}
                                </Typography>
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t(
                                    'Подписались - количество аккаунтов, подписавшихся за выбранный период.',
                                )}
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t(
                                    'Отписались - количество аккаунтов, отписавшихся от профиля за выбранный период.',
                                )}
                            </Typography>
                        </>
                    }
                    statsSlot={
                        <>
                            <BusinessStatisticMainItem
                                text={t('Количество аккаунтов, подписавшихся на профиль')}
                                displayValue={subscribers.total.display}
                                diffValue={subscribers.total.diffValue}
                                diffDisplay={subscribers.total.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Подписались')}
                                displayValue={subscribers.subscribed.display}
                                diffValue={subscribers.subscribed.diffValue}
                                diffDisplay={subscribers.subscribed.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Отписались')}
                                displayValue={subscribers.unsubscribed.display}
                                diffValue={subscribers.unsubscribed.diffValue}
                                diffDisplay={subscribers.unsubscribed.diffDisplay}
                            />
                        </>
                    }
                    borderRight={{ xs: 'none', sm: '1px solid var(--divider)' }}
                />
            ) : null}

            {interactions ? (
                <BusinessStatisticSection
                    title={t('Взаимодействия')}
                    helpMessage={
                        <>
                            <Typography variant="caption" weight="bold" color="var(--color-invert)">
                                {t('Взаимодействия')}
                                <Typography
                                    variant="caption"
                                    color="var(--color-invert)"
                                    display="inline"
                                >
                                    {t(
                                        ' - количество действий, которые совершали пользователи с контентом за выбранный период с изменением относительно предыдущего периода.',
                                    )}
                                </Typography>
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t(
                                    'Клики по ссылкам - количество переходов по ссылкам из поста и профиля.',
                                )}
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t('Лайки - количество лайков у контента.')}
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t('Шаринги - количество шарингов контента.')}
                            </Typography>
                            <Typography variant="caption" color="var(--color-invert)">
                                {t('Сохранения - количество сохранненого контента в избранное.')}
                            </Typography>
                        </>
                    }
                    statsSlot={
                        <>
                            <BusinessStatisticMainItem
                                text={t(
                                    'Количество действий, которые совершили пользователи с контентом',
                                )}
                                displayValue={interactions.total.display}
                                diffValue={interactions.total.diffValue}
                                diffDisplay={interactions.total.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Клики по ссылке')}
                                displayValue={interactions.clicks.display}
                                diffValue={interactions.clicks.diffValue}
                                diffDisplay={interactions.clicks.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Лайки')}
                                displayValue={interactions.likes.display}
                                diffValue={interactions.likes.diffValue}
                                diffDisplay={interactions.likes.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Шаринги')}
                                displayValue={interactions.shares.display}
                                diffValue={interactions.shares.diffValue}
                                diffDisplay={interactions.shares.diffDisplay}
                            />
                            <BusinessStatisticItem
                                title={t('Сохранения')}
                                displayValue={interactions.saves.display}
                                diffValue={interactions.saves.diffValue}
                                diffDisplay={interactions.saves.diffDisplay}
                            />
                        </>
                    }
                />
            ) : null}
        </Flex>
    );
};
